import {getQuery, postQuery} from "@/modules/common/utils";

export const getClientPackages = ({client_uid, matter_uid}) => {
  return getQuery(`platform/v1/clients/${client_uid}/payment/client_packages`, {
    new_api: true,
    matter_uid,
  })
}

export const getBusinessPackages = () => {
  return getQuery(`platform/v1/payment/packages`, {
    use_platform_api: true,
    teams_view_filter: "all",
    include_items: true
  })
}

export const removeExpiredPacakges = (packages) => {
  const yesterdayDateObj = new Date()
  yesterdayDateObj.setDate(yesterdayDateObj.getDate() - 1)

  return packages.filter(currPackage => {
    const packageExpiration = new Date(currPackage.valid_until)
    return packageExpiration >= yesterdayDateObj && currPackage.bookings_usage !== currPackage.total_bookings
  })
}

export const removeNonActivePacakges = (packages) => {
  return packages.filter(currPackage => {
    return currPackage.active
  })
}

export const isServiceInPackage = (service_uid, packages) => {
  return !!getPackageContainingService(service_uid, packages)
}

export const getPackageContainingService = (service_uid, packages) => {
  return packages && packages.find(currPackage => {
    return !!getCreditContainingService(service_uid, currPackage)
  })
}

export const getCreditContainingService = (service_uid, currPackage) => {
  if(!currPackage || !service_uid) {
    return
  }
  let res = currPackage.booking_credits && currPackage.booking_credits.find(credit => {
    if(credit.bookings_usage === credit.total_bookings) {
      return false
    }
    return credit.credit_items.some(service => service.item_id === service_uid)
  })
  return res
}

export const isServiceInPackages = (service_uid, packages) => {
  return packages && packages.find(currPackage => {
    return !!isPackageContainService(service_uid, currPackage.items)
  })
}

export const isPackageContainService = (service_uid, packageItems) => {
  return packageItems && packageItems.find(item => {
    return !!isItemContainService(service_uid, item.services)
  })
}

export const isItemContainService = (service_uid, itemServices) => {
  return itemServices && itemServices.some(service => {
    return service.id === service_uid
  })
}

export const redeemPackage = (payment_status_uid, client_uid, matter_uid) => {
  const params = {
    new_api: true,
    payment_status_id: payment_status_uid,
    client_id: client_uid,
    matter_uid: matter_uid,
  }
  return postQuery(`platform/v1/payment/client_packages/update_usage`, params)
}





export default {
  getClientPackages,
  getBusinessPackages,
  removeExpiredPacakges,
  removeNonActivePacakges,
  isServiceInPackage,
  isServiceInPackages,
  redeemPackage,
  getPackageContainingService,
  getCreditContainingService,

}
